import { Visibility, VisibilityOff } from '@mui/icons-material';

interface Props {
    showPassword: boolean;
}

export const PasswordInputIcon = ({ showPassword }: Props) => {
    return showPassword ? <Visibility color="secondary" /> : <VisibilityOff color="secondary" />;
};
